import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { useNotifyMeButton } from "../../hooks/useNotifyMeButton";
import NotifyMeJoinLoyaltyModal from "./NotifyMeJoinLoyaltyModal";
import NotifyMeMarketingOptInModal from "./NotifyMeMarketingOptInModal";

interface NotifyMeButtonProps {
  customerState: string;
  setCustomerState: (state: string) => void;
}

const NotifyMeButton = ({
  customerState,
  setCustomerState,
}: NotifyMeButtonProps) => {
  const {
    buttonText,
    isMixAndMatch,
    handleClick,
    joinLoyaltyModal,
    marketingModal,
  } = useNotifyMeButton({ customerState, setCustomerState });

  return (
    <>
      <Button
        type={
          isMixAndMatch ? BUTTON_TYPES.loyaltyFullWidth : BUTTON_TYPES.loyalty
        }
        handleClick={handleClick}
        ariaLabel={buttonText}
      >
        <div>{buttonText}</div>
      </Button>
      <NotifyMeJoinLoyaltyModal
        open={joinLoyaltyModal.open}
        closeModal={joinLoyaltyModal.closeModal}
        onJoin={joinLoyaltyModal.onJoin}
        onError={joinLoyaltyModal.onError}
      />
      <NotifyMeMarketingOptInModal
        open={marketingModal.open}
        closeModal={marketingModal.closeModal}
        onOptIn={marketingModal.onOptIn}
        onError={marketingModal.onError}
      />
    </>
  );
};

export default NotifyMeButton;
